{
  "version": 1,
  "asset_id": "18f245b6-a246-46d4-82c8-ad4577d035cc",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/18f245b6-a246-46d4-82c8-ad4577d035cc/band-tubing-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/18f245b6-a246-46d4-82c8-ad4577d035cc/band-tubing-800.webp",
  "original_filename": "band-tubing-800.webp",
  "size": 21070,
  "content_type": "image/webp",
  "created_at": "2026-09-20T00:20:54Z"
}
